import { Translations } from './en';

const fr: Translations = {
  listHeaderTitle: 'Certifications',
  listHeaderSubtitle: 'Créez des certifications pour tester les contributeurs',
  createButtonLabel: 'Créer une certification',
  filtersButtonLabel: 'Filtres',
  notifications: {
    requestAccessSuccess: 'La demande d’accès à la certification a été envoyée !',
    requestAccessError: 'La demande d’accès à la certification a échoué',
  },
  createModal: {
    title: 'Ajouter une certification',
    subtitle: 'Créez une certification',
    namePlaceholder: 'Exemple : Anglais',
  },
  table: {
    accessLevel: 'Niveau d’accès',
    name: 'Nom',
    participantsNumber: 'Nombre de participants',
    timeAverage: 'Temps moyen',
    scoreAverage: 'Note moyenne',
    state: 'Statut',
    successRate: 'Taux de réussite',
  },
};

export default fr;
